import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const TopicDetails = ({ topic, setTopic, details, setDetails }) => {
  return (
    <div>
      <Text
        variant={TEXT_VARIANTS.BODY_LIGHT}
        className="lesson-generate-label"
        component="div"
      >
        {t('actions.lesson_generate_modal.describe_topic_lesson')}{' '}
        <span className="required">*</span>
      </Text>
      <input
        className="NewInput NewInput--white NewInput--fw LessonGenerateModal--textbox"
        placeholder={t(
          'actions.lesson_generate_modal.describe_topic_lesson_placeholder',
        )}
        type="text"
        onChange={e => setTopic(e.target.value)}
        value={topic}
        maxLength="255"
      />
      <Text
        variant={TEXT_VARIANTS.BODY_LIGHT}
        className="lesson-generate-label"
        component="div"
      >
        {t('actions.lesson_generate_modal.tell_us_details')}
      </Text>
      <textarea
        className="LessonGenerateModal--textarea NewInput NewInput--white NewInput--fw"
        onChange={e => setDetails(e.target.value)}
        rows="3"
        value={details}
        placeholder={t(
          'actions.lesson_generate_modal.tell_us_details_placeholder',
        )}
      />
    </div>
  );
};

export default TopicDetails;
